import { AxiosResponse } from 'axios';
import apiClient from './client';
import { ApiResponseDto } from '../interfaces/apiResponse';
import { ClientConfiguration } from '../interfaces/clientConfiguration';

interface ClientConfigurationService {
  get(): Promise<ClientConfiguration>;
}

const endpoints = {
  get: '/client-configuration',
}

export const clientConfigurationService: ClientConfigurationService = {
  get: async (): Promise<ClientConfiguration> => {
    const response: AxiosResponse<ApiResponseDto<ClientConfiguration>> = await apiClient.get(endpoints.get);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
